import React from 'react';
import axios from 'axios';
import { domainWeb } from '../config/constants';
import { useLocation, Navigate, useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { authenticated } from '../recoil/auth';

async function checkToken(token) {
    return await axios.get(`${domainWeb}/admin/info`, 
            {headers: {
                'Content-Type': 'application/json', 
                'Accept': 'application/json', 
                'Authorization': 'Bearer '+token
            }},
        );
}

const Authenticated = (props) => {
    const [auth, setAuth] = useRecoilState(authenticated);
    const location = useLocation();
    const navigate = useNavigate();

    if (!auth.check) {
        return <Navigate to="/login" state={{ from: location }} />
    }

    checkToken(auth.token).then().catch((error) => {
        console.error(error);
        setAuth({
            check: false,
            token: null,
            isExpired: true,
          });
          window.localStorage.removeItem('token');
          navigate("/");
    });
    
    return props.render;
};

export default Authenticated